import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
export type FestivalStatus = 'IN_PROGRESS' | 'OPENING_THIS_WEEK' | 'PRE_APPLY_OPEN' | 'UPCOMING' | 'NOT_YET_ANNOUNCED' | 'UNDETERMINED' | 'ENDED';
const STATUS_STYLE: Record<FestivalStatus, string> = {
  IN_PROGRESS: 'bg-M-400 text-Gray-white',
  OPENING_THIS_WEEK: 'bg-P-300 text-Gray-white',
  PRE_APPLY_OPEN: 'bg-B-400 text-Gray-white',
  UPCOMING: 'bg-B-400 text-Gray-white',
  NOT_YET_ANNOUNCED: 'bg-Gray-400 text-Gray-white',
  UNDETERMINED: 'bg-Gray-400 text-Gray-white',
  ENDED: 'bg-Gray-500 text-Gray-white'
};
const STATUS_LABEL: Record<FestivalStatus, string> = {
  IN_PROGRESS: '진행중',
  OPENING_THIS_WEEK: '이번 주 예정',
  PRE_APPLY_OPEN: '사전신청',
  UPCOMING: '예정',
  NOT_YET_ANNOUNCED: '미정',
  UNDETERMINED: '미정',
  ENDED: '종료'
};
interface FestivalStatusBadgeProps {
  status: FestivalStatus;
  className?: string;
}
export const FestivalStatusBadge = t0 => {
  const $ = _c(9);
  const {
    status,
    className
  } = t0;
  const t1 = STATUS_STYLE[status];
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("inline-flex items-center gap-4 rounded-xsmall px-6 py-2 font-600 typo-caption1", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== status) {
    t3 = status === "IN_PROGRESS" ? <span aria-hidden="true" className="relative flex size-6"><span className="relative size-6 rounded-pill bg-Gray-white" /></span> : null;
    $[3] = status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = STATUS_LABEL[status];
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};